import { formatDate } from 'lib/helpers/dateUtils';
import { Capitalize } from 'lib/helpers/utility';

import ColorCircle from 'components/admin/pages/Practices/lib/ColorCircle';

import Actions from '../components/Actions';
import FullNameCell from '../components/FullNameCell';

export const getDefaultColumns = (principalUserId) => [
  {
    field: 'fullName',
    headerName: 'Name',
    cellRenderer: ({ data }) => <FullNameCell data={data} principalUserId={principalUserId} />
  },
  { field: 'role', headerName: 'Role', valueFormatter: ({ value }) => Capitalize(value) },
  {
    field: 'created_at',
    headerName: 'Invited',
    valueFormatter: ({ value }) => formatDate(value, null)
  },
  { field: 'color', headerName: 'Color', cellRenderer: ColorCircle, maxWidth: 100 },
  {
    field: 'actions',
    headerName: '',
    cellRenderer: (params) => <Actions index={params.rowIndex} data={params.data} />,
    maxWidth: 100,
    minWidth: 36,
    resizable: false
  }
];
